import React, { useState } from "react";
import {
  Grid,
  Hidden,
  Typography,
  makeStyles,
  Menu,
  MenuItem,
  Fade,
  IconButton,
} from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import { Link } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  topbar: {
    backgroundColor: "#f4b547",
    minHeight: "2.5rem",
    display: "flex",
    alignItems: "center",
    padding: "10px",
  },
  navBar: {
    backgroundColor: "#fff",
    minHeight: "5rem",
    display: "flex",
    alignItems: "center",
    boxShadow: "0px 2px 2px 1px rgba(0, 0, 0, 0.2)",
  },
  topbarText: {
    color: "rgba(0,0,0)",
  },
  topLink: {
    color: "rgba(0,0,0)",
    textDecoration: "none",
    "&:hover": {
      color: "#fff",
    },
  },
  signInWriteup: {},
  signInButton: {
    textDecoration: "none",
    color: "#f4b547",
    display: "flex",
    border: "1px solid #f4b547",
    borderRadius: "0.2rem",
    height: "2rem",
    alignItems: "center",
    justifyContent: "center",
    maxWidth: "80%",
    [theme.breakpoints.only("xs")]: {
      marginLeft: "0.1rem",
    },
  },
  bookButton: {
    textDecoration: "none",
    backgroundColor: "#f4b547",
    display: "flex",
    color: "#ffffff",
    borderRadius: "0.2rem",
    height: "2rem",
    alignItems: "center",
    justifyContent: "center",
    maxWidth: "80%",
    [theme.breakpoints.only("xs")]: {
      marginLeft: "0.1rem",
    },
  },
  link: {
    color: "rgba(50,50,50)",
    textDecoration: "none",
    marginRight: "1.5rem",
    display: "flex",
    alignItems: "center",
    "&:hover": {
      color: "#f4b547",
    },
  },
}));

const allLinks = [
  {
    link: "/",
    label: "Home",
  },
  {
    link: "/about",
    label: "About Us",
  },
  {
    link: "/contact",
    label: "Contact Us",
  },
  {
    link: "/careers",
    label: "Careers",
  },
  {
    link: "/blog",
    label: "Blog",
  },
];

const HeaderComponent = () => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <React.Fragment>
      <Hidden only={["xs", "sm"]}>
        <Grid className={classes.topbar}>
          <Grid container>
            <Grid item md={6}>
              <Typography className={classes.topbarText} align="left">
                Nigeria's No. 1 Tractor Leasing Platform
              </Typography>
            </Grid>
            <Grid item md={6}>
              <Typography className={classes.topbarText} align="right">
                Support:{" "}
                <a className={classes.topLink} href="mailto:info@tractrac.co">
                  info@tractrac.co
                </a>{" "}
                or{" "}
                <a className={classes.topLink} href="tel:2348064648720">
                  08064648720
                </a>
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Hidden>
      <Hidden only={["xs", "sm", "md"]}>
        <Grid className={classes.navBar}>
          <Grid container>
            <Grid item md={3}>
              <img
                src="https://res.cloudinary.com/tractrac-global/image/upload/v1625573298/tractrac_logo_png_uuacar.webp"
                style={{ width: "150px", height: "auto", marginLeft: "50px" }}
                alt="tractrac logo"
              />
            </Grid>
            <Grid
              item
              md={6}
              style={{ display: "flex", justifyContent: "flex-end" }}
            >
              {allLinks.map((lin) => (
                <Link key={lin.label} className={classes.link} to={lin.link}>
                  <Typography>{lin.label}</Typography>
                </Link>
              ))}
            </Grid>
            <Grid item md={2}>
              <a href="/login" className={classes.bookButton}>
                <Typography align="center" className={classes.signInWriteup}>
                  Book a Tractor
                </Typography>
              </a>
            </Grid>
            <Grid item md={1}>
              <Link to="/login" className={classes.signInButton}>
                <Typography align="center" className={classes.signInWriteup}>
                  Sign in
                </Typography>
              </Link>
            </Grid>
          </Grid>
        </Grid>
      </Hidden>
      <Hidden only={["md", "lg", "xl"]}>
        <Grid className={classes.navBar}>
          <Grid container justify="center" alignItems="center">
            <Grid item xs={9}>
              <img
                src="https://res.cloudinary.com/tractrac-global/image/upload/v1625573298/tractrac_logo_png_uuacar.webp"
                style={{ width: "100px", height: "auto", marginLeft: "50px" }}
                alt="tractrac logo"
              />
            </Grid>
            <Grid item xs={3}>
              <IconButton
                aria-controls="fade-menu"
                aria-haspopup="true"
                onClick={handleClick}
              >
                <MenuIcon color="primary" />
              </IconButton>
              <Menu
                id="fade-menu"
                anchorEl={anchorEl}
                keepMounted
                open={open}
                onClose={handleClose}
                TransitionComponent={Fade}
              >
                <a
                  href="https://tractracplus.com"
                  className={classes.bookButton}
                >
                  <MenuItem onClick={handleClose}>Book Tractor</MenuItem>
                </a>
                <Link to="/login" className={classes.signInButton}>
                  <MenuItem onClick={handleClose}>Sign in</MenuItem>
                </Link>
                {allLinks.map((lin) => (
                  <Link key={lin.label} className={classes.link} to={lin.link}>
                    <MenuItem onClick={handleClose}>{lin.label}</MenuItem>
                  </Link>
                ))}
              </Menu>
            </Grid>
          </Grid>
        </Grid>
      </Hidden>
    </React.Fragment>
  );
};
export default HeaderComponent;
